import type {
    ExtensionDefinition,
    FrontendPlugin,
} from "@backstage/frontend-plugin-api";
import {
    ApiBlueprint,
    createApiFactory,
    createFrontendPlugin,
    discoveryApiRef,
    identityApiRef,
} from "@backstage/frontend-plugin-api";
import { GoogleClient } from "@internal/backstage-plugin-google-common";
import { googleApiRef } from "@internal/backstage-plugin-google-react";

/**
 * Registers the {@link googleApiRef} API factory, providing a {@link GoogleClient}
 * instance backed by the Backstage discovery and identity APIs.
 */
const googleApi: ExtensionDefinition = ApiBlueprint.make({
    params: defineParams =>
        defineParams(
            createApiFactory({
                api: googleApiRef,
                deps: {
                    discoveryApi: discoveryApiRef,
                    identityApi: identityApiRef,
                },
                factory: ({ discoveryApi, identityApi }) =>
                    new GoogleClient({ discoveryApi, identityApi }),
            })
        ),
});

/**
 * The Google frontend plugin.
 *
 * Registers the core {@link googleApiRef} API extension. Frontend modules
 * (e.g. `google-module-gcp-security-findings`) attach additional extensions
 * to this plugin at runtime.
 *
 * @public
 */
const googlePlugin: FrontendPlugin = createFrontendPlugin({
    pluginId: "google",
    extensions: [googleApi],
});

export default googlePlugin;
